(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-password"] && !Shopify.designMode) return;
  try {
    
(function(){
  var el = document.querySelector('[data-spk-drop-target]');
  if(!el) return;
  var target = new Date(el.getAttribute('data-spk-drop-target')).getTime();
  if(isNaN(target)) return;
  var ctas = document.querySelectorAll('[data-spk-cta]');
  var sr  = document.querySelector('[data-spk-sr]');
  var $d = el.querySelector('[data-d]'), $h = el.querySelector('[data-h]'),
      $m = el.querySelector('[data-m]'), $s = el.querySelector('[data-s]');
  var timer = null;
  function pad(n){ return (n < 10 ? '0' : '') + n; }
  function goLive(){
    var span = document.createElement('span');
    span.className = 'spk-pw__live';
    span.textContent = el.getAttribute('data-spk-live-text') || "We're live";
    el.textContent = '';
    el.appendChild(span);
    el.className += ' is-live';
    el.setAttribute('aria-hidden', 'false');
    if(sr) sr.hidden = true;
    for(var i = 0; i < ctas.length; i++){
      var cta = ctas[i];
      var label = cta.getAttribute('data-spk-live-label'), href = cta.getAttribute('data-spk-live-href');
      if(label) cta.textContent = label;
      // Once it points at the store it is a plain link, no longer the SMS popup.
      if(href){
        cta.setAttribute('href', href);
        cta.removeAttribute('data-spk-sms-open'); cta.removeAttribute('aria-haspopup'); cta.removeAttribute('aria-controls');
      }
    }
  }
  function tick(){
    var diff = target - Date.now();
    if(diff <= 0){
      goLive();
      if(timer) clearInterval(timer);
      return true;
    }
    var s = Math.floor(diff / 1000);
    $d.textContent = pad(Math.floor(s / 86400));
    $h.textContent = pad(Math.floor(s % 86400 / 3600));
    $m.textContent = pad(Math.floor(s % 3600 / 60));
    $s.textContent = pad(s % 60);
    return false;
  }
  if(!tick()) timer = setInterval(tick, 1000);
})();

(function(){
  // SPK-PW-SMS (2026-10-21): the early-access CTA opens Postscript's embedded form in a
  // modal. Modifier-clicks, browsers without <dialog>, and an undrawn form follow the
  // pscrpt.io href instead.
  var dlg = document.querySelector('[data-spk-sms]');
  if(!dlg || typeof dlg.showModal !== 'function') return;
  var root = document.documentElement, prevOverflow = '';
  function onClick(e){
    // goLive() strips the attribute; after the drop the button is a plain link to the store.
    if(!e.currentTarget.hasAttribute('data-spk-sms-open')) return;
    // Form not drawn (still loading, or Postscript failed): an empty popup is worse than the link.
    if(!dlg.hasAttribute('data-spk-ready')) return;
    if(e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    e.preventDefault();
    // Opened from the lookbook it stacks on top; closing it lands back in the lookbook.
    prevOverflow = root.style.overflow;
    root.style.overflow = 'hidden';
    dlg.showModal();
  }
  var ctas = document.querySelectorAll('[data-spk-cta]');
  for(var i = 0; i < ctas.length; i++) ctas[i].addEventListener('click', onClick);
  dlg.querySelector('[data-spk-sms-close]').addEventListener('click', function(){ dlg.close(); });
  // A click outside the panel lands on the dialog itself (the backdrop); close on that.
  dlg.addEventListener('click', function(e){
    if(e.target !== dlg) return;
    var r = dlg.getBoundingClientRect();
    if(e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) dlg.close();
  });
  dlg.addEventListener('close', function(){ root.style.overflow = prevOverflow; });
})();

(function(){
  // SPK-PW-LEAD: Meta "Lead" only for a fully finished signup (2026-10-21). Postscript fires
  // "complete" when the form reaches its last step (the success screen), and subscriberStatus
  // is "new" only once the texted code has been verified. submit:success and step-change
  // both fire at the phone step, before the code, so they never count. A number that is
  // already subscribed skips the code and completes as "existing": not a new lead, no Lead.
  // fbq is not this theme's: the WeTracked app's script tag installs it (pixel
  // 2273928696771459) once marketing consent allows. No fbq, no Lead. One Lead per page view.
  var sent = false;
  document.addEventListener('postscript:embedded-form', function(e){
    var d = e.detail || {};
    if(sent || d.type !== 'complete' || d.subscriberStatus !== 'new' || typeof window.fbq !== 'function') return;
    sent = true;
    // Keyed on the subscriber so Meta can dedupe a repeat (e.g. a reload on the success screen).
    window.fbq('track', 'Lead', { content_name: 'Early access SMS' }, { eventID: 'spk-lead-' + d.subscriberId });
  });
})();

(function(){
  var lb = document.querySelector('[data-spk-lb]'), open = document.querySelector('[data-spk-lb-open]');
  // No <dialog> support = no lookbook; the button stays hidden rather than doing nothing.
  if(!lb || !open || typeof lb.showModal !== 'function') return;
  open.hidden = false;
  open.addEventListener('click', function(){
    lb.showModal();
    document.documentElement.style.overflow = 'hidden';
  });
  lb.querySelector('[data-spk-lb-close]').addEventListener('click', function(){ lb.close(); });
  lb.addEventListener('close', function(){
    document.documentElement.style.overflow = '';
    open.focus();
  });
  // Rotating a phone past 900px wide hides the dialog by CSS; close it so the scroll lock lifts.
  var wide = window.matchMedia('(min-width: 900px)');
  var onWide = function(){ if(wide.matches && lb.open) lb.close(); };
  if(wide.addEventListener) wide.addEventListener('change', onWide); else if(wide.addListener) wide.addListener(onWide);
})();

  } catch(e) { console.error(e); }
})();
})();
